import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1d8wi11-0"
})(["display:flex;position:relative;width:100%;padding:", " 9px;border:1px solid ", ";border-radius:4px;box-shadow:", " 0 0 2px inset;margin-bottom:9px;background-color:rgba(255,255,255,0.1);font-family:", ";font-size:1rem;line-height:1.5;"], function (_ref) {
  var isCompact = _ref.isCompact;
  return isCompact ? '9px' : '12px';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.ui;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.ui;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.bodyFontFamily;
});
export var StyledInput = styled.input.withConfig({
  displayName: "partials__StyledInput",
  componentId: "sc-1d8wi11-1"
})(["flex-grow:1;width:100%;height:30px;padding:0 4px;font-family:", ";", ";::placeholder{padding-left:1px;}&:focus{::placeholder{color:", ";}}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.bodyFontFamily;
}, getFont(0), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.fontLL;
});
export var Chip = styled.div.withConfig({
  displayName: "partials__Chip",
  componentId: "sc-1d8wi11-2"
})(["display:inline-block;flex-shrink:0;height:30px;padding:4px 12px;border-radius:16px;margin-right:6px;background-color:", ";", ";", ";", ";svg{margin-left:4px;vertical-align:middle;}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.uiL;
}, getFont(-1), function (_ref8) {
  var isCompact = _ref8.isCompact;
  return isCompact && css(["transition:0.1s ease-in;"]);
}, function (_ref9) {
  var isFocused = _ref9.isFocused,
    isCompact = _ref9.isCompact;
  return isFocused && isCompact && css(["position:absolute;top:0;left:4px;transform:translateY(-50%) scale(0.95);"]);
});
export var CloseIcon = styled.span.withConfig({
  displayName: "partials__CloseIcon",
  componentId: "sc-1d8wi11-3"
})(["margin:auto 0;cursor:pointer;"]);
export var SearchIcon = styled.span.withConfig({
  displayName: "partials__SearchIcon",
  componentId: "sc-1d8wi11-4"
})(["margin:auto 0;color:", ";svg{vertical-align:middle;", ";", ";}"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.ui;
}, function (_ref11) {
  var isCompact = _ref11.isCompact;
  return isCompact && css(["width:18px;height:18px;"]);
}, maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      width: 20px;\n      height: 20px;\n    "]))));